import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './UnloadingForm.html?raw';
import ResourcePicker from '../../moreCore/UI/ResourcePicker/ResourcePicker';
import "../../moreCore/UI/ResourcePicker/ResourcePicker";
import "../../moreCore/UI/GenericDialog/GenericDialog";

import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';
import "../../moreCore/UI/SearchSelect/SearchSelect";

import TruckTable from './Trucktable/Trucktable';

import dojoDate from 'dojo/date';

import { TiInterfaces } from "./TiTypes";



class TiUnloadingForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    protected lastFilterDate: Date = null;
    protected lastFilterDateTrucktable: Date = null;

    protected bookingResourcePicker: MdsLax<InstanceType<typeof ResourcePicker>> = null;
    public resourcePickerCalendarContainer: HTMLDivElement;
    public dateFilterLabelsection: HTMLDivElement;
    public truckTabledateFilterLabelsection: HTMLDivElement;

    public section1_bookingFilter: HTMLElement;
    public calendarControlSection: HTMLElement;
    public selectAndMoveBookingSection: HTMLElement;
    public truckTableContainer: HTMLElement;
    public truckTable: MdsLax<InstanceType<typeof TruckTable>>;
    public btnSave: HTMLButtonElement;

    inputDivision: MdsLax<InstanceType<typeof SearchSelect>>;
    inputTerminal: MdsLax<InstanceType<typeof SearchSelect>>;

    navigationBar: HTMLElement;

    divisionID: string;
    terminalID: string;
    bookingID: string;

    currentDndItem: ResourcePicker.ResourceEntry;
    currentDndNode: HTMLElement;


    s1_bookingFilter_Valid: boolean = true;
    s2_bookingSelect_Valid: boolean = true;

    s1_bookingFilter_Summary: string;
    s1_bookingSelect_Summary: string;

    private _loadingTimeout: number;

    private divisionsRegistry: Array<{ ID: string, name_address: string }> = [];

    public autonavigate() {
        this.inputDivision.setValue(this.divisionID);
        this.inputTerminal.setValue(this.terminalID);
    }

    private _onClick_ChangeDateBackward(evt: MouseEvent) {


        this.changeFilterDate(-1);
    }
    private _onClick_ChangeDateForward(evt: MouseEvent) {
        this.changeFilterDate(1);
    }

    private _onClick_ChangeDateBackward_Trucktable(evt: MouseEvent) {
        this.changeFilterDateTrucktable(-1);
    }
    private _onClick_ChangeDateForward_Trucktable(evt: MouseEvent) {
        this.changeFilterDateTrucktable(1);
    }

    private changeFilterDate(steps: number = 0): void {
        this.lastFilterDate = dojoDate.add(this.lastFilterDate, "day", steps);
        this.lastFilterDateTrucktable = this.lastFilterDate;

        this._setupResourcePicker();

        this.changeFilterDateBookedSectionsTrucktable();
    }

    private changeFilterDateTrucktable(steps: number = 0): void {
        this.lastFilterDateTrucktable = dojoDate.add(this.lastFilterDateTrucktable, "day", steps);

        //this._setupResourcePicker();
        this.changeFilterDateBookedSectionsTrucktable();
    }

    private dateStepWidth: number = 8;
    private dateSteps: number = 0;
    private changeFilterDateBookedSections(steps: number = 0) {

        if (steps != 0 && typeof (steps) == "number") {
            this.dateSteps = this.dateSteps + steps;

            //this.lastFilterDate.setHours(24 * this.dateStepWidth * steps);
        }

        let currentStart = this.dateToString(this.lastFilterDate, "EEE dd.MM.yyyy");
        let newDate = new Date(this.lastFilterDate.valueOf());
        newDate.setHours(24 * this.dateStepWidth * 1);
        let currentEnd = this.dateToString(newDate, "EEE dd.MM.yyyy");
        this.UiModder.domAttr.set(this.dateFilterLabelsection, "innerHTML", this.stringFormat("{0} - {1}", currentStart, currentEnd));
    }

    private changeFilterDateBookedSectionsTrucktable(steps: number = 0) {

        if (steps != 0 && typeof (steps) == "number") {
            this.dateSteps = this.dateSteps + steps;

            //this.lastFilterDate.setHours(24 * this.dateStepWidth * steps);
        }

        let currentStart = this.dateToString(this.lastFilterDateTrucktable, "EEE dd.MM.yyyy");
        let newDate = new Date(this.lastFilterDateTrucktable.valueOf());
        newDate.setHours(24 * this.dateStepWidth * 1);
        let currentEnd = this.dateToString(newDate, "EEE dd.MM.yyyy");
        this.UiModder.domAttr.set(this.truckTabledateFilterLabelsection, "innerHTML", this.stringFormat("{0} - {1}", currentStart, currentEnd));

        if (this.truckTable) {
            this.truckTable.startDay = this.lastFilterDateTrucktable;
            this.truckTable.drawTable();
        }
    }


    private _onChange_InputDivision(value: string) {
        //console.debug("_onChange_InputDivision", value);
        localStorage.setItem("Ti_DivisionID", value);
        this.divisionID = value;
        
        //this.bookingID = null;
        //this.routeSectionSlotID = null;

        //this.UiModder.domClass.toggle(this.inputRouteSection.domNode, "w3-disabled", !this.divisionID);

        //this.checkStep1();

        if (this.divisionID) {
            //this.inputTerminal.setValue(null);
            this.loadTerminals();
        }

    }

    private _onChange_InputTerminal(value: string) {
        localStorage.setItem("Ti_TerminalID", value);
        this.terminalID = value;
        
        //this.bookingID = null;

        if (this.terminalID) {
            this.changeFilterDate(0);
            this.loadTrucks();
            this.emit("changeStep1");
        }

    }

    private _onClick_BtnSaveTrucktable() {
        this.truckTable.saveChanges();
    }

    private loadDivisions(): void {

        this.inputDivision.StandbyStart();

        var url = window.appRoot + "TransportIntermodal/LoadDivisions";

        let data = {

        };
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onLoadDivisionsResponse),
            lang.hitch(this, this._onLoadDivisionsError),
            false // sync
        );
    }

    private _onLoadDivisionsResponse(response: Array<{ ID: string, name_address: string }>) {
        this.inputDivision.StandbyStop();
        let result = false;
        for (let entity of response) {
            if (entity.ID == this.divisionID) {
                result = true;
                break;
            }
        }

        if (result != true) {
            this.divisionID = null;
        }

        this.inputDivision.setSelectionListLEGACY(response);
        this.inputDivision.setValue(this.divisionID);

        this.divisionsRegistry = response;
    }

    private _onLoadDivisionsError(error: more.requestErrorMessage) {
        this.inputDivision.StandbyStop();
        //this.showMessage("loading divisions failed", error.Message, true);

        //alert(error.Message);

    }

    private loadTerminals(): void {

        this.inputTerminal.StandbyStart();

        var url = window.appRoot + "TransportIntermodal/LoadTerminals";

        let data = {
            divisionID: this.divisionID
        };
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onLoadTerminalsResponse),
            lang.hitch(this, this._onLoadTerminalsError),
            false // sync
        );
    }

    private _onLoadTerminalsResponse(response: Array<{ ID: string, displayname: string }>) {
        this.inputTerminal.StandbyStop();
        let result = false;
        for (let entity of response) {
            if (entity.ID == this.divisionID) {
                result = true;
                break;
            }
        }

        this.inputTerminal.setSelectionListLEGACY(response);
        this.inputTerminal.setReadonly(false);
        if (this.terminalID) {
            this.inputTerminal.setValue(this.terminalID);
        }

    }

    private _onLoadTerminalsError(error: more.requestErrorMessage) {
        this.inputTerminal.StandbyStop();
        //this.showMessage("loading divisions failed", error.Message, true);

        //alert(error.Message);

    }
    private loadTrucks(): void {

        this.StandbyStart(this.calendarControlSection.parentElement, "trucktable", "trucktable");

        var url = window.appRoot + "TransportIntermodal/LoadTrucksByTerminal";

        let data = {
            terminalID: this.terminalID,
            divisionID: this.divisionID
        };
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onLoadTrucksResponse),
            lang.hitch(this, this._onLoadTrucksError),
            false // sync
        );
    }

    private _onLoadTrucksResponse(response: Array<TiInterfaces.TiTruck>) {
        this.StandbyStop("trucktable");
        

        if (this.truckTable != null) {
            this.truckTable.destroy();
        }
        this.truckTable = new TruckTable();
        this.truckTable.startDay = this.lastFilterDate;
        this.truckTable.terminalID = this.terminalID;
        this.truckTable.on("isDirty", lang.hitch(this, this._onTrucktable_IsDirty));
        this.truckTable.on("saved", lang.hitch(this, this._onTrucktable_Saved));
        this.truckTable.trucks = response;
        this.truckTable.placeAt(this.truckTableContainer, "only");
        this.truckTable.domNode.style.minHeight = "4em";
        this.truckTable.drawTable();
        //this.inputTerminal.setData(response);
        //this.inputTerminal.setReadonly(false);
        //this.inputTerminal.setValue(this.divisionID);
    }

    private _onTrucktable_IsDirty(dirty) {
        console.log("_onTrucktable_IsDirty", dirty);

        this.disableNode(this.btnSave, !dirty);

    }
    private _onTrucktable_Saved() {
        this.emit("saved");
    }

    private _onLoadTrucksError(error: more.requestErrorMessage) {
        //this.inputTerminal.StandbyStop();
        //this.showMessage("loading divisions failed", error.Message, true);
        this.StandbyStop();
        alert(error.Message);
    }

    public setFilterDate(date: Date) {
        this.lastFilterDate = date;
        this.lastFilterDate.setHours(0);
        this.lastFilterDate.setMinutes(0);
        this.lastFilterDate.setSeconds(0);
        this.changeFilterDateBookedSections();
    }

    protected _setupResourcePicker(): void {

        let pFilterDate = this.getUrlParameterValue("filterDate");
        let pBookingId = this.getUrlParameterValue("booking");

        if (this.bookingID && pBookingId == false) {
            pBookingId = this.bookingID;
        }

        if (this.lastFilterDate == null) {
            if (pFilterDate) {
                this.setFilterDate(new Date(pFilterDate))
            } else {
                this.setFilterDate(new Date())
            }
        }

        if (!this.terminalID) {
            return;
        }

        let jsonData = {
            "filterDate": this.dateToLocalISOString(this.lastFilterDate),
            "bookingID": pBookingId == false ? null : pBookingId,
            "terminalID": this.terminalID
        };

        this.changeFilterDateBookedSections();

        if (this._loadingTimeout) {
            clearTimeout(this._loadingTimeout);
        }

        this._loadingTimeout = setTimeout(lang.hitch(this, this._loadResourcePickerData_Worker, jsonData), 300);        
    }

    protected _loadResourcePickerData_Worker(jsonData) {
        this.StandbyStart(this.calendarControlSection.parentElement, "resourcepicker", "resourcepicker");
        this.RequestManager.callfunction("Webtool_API_TransportIntermodal__GetUnloadingFormResourcePickerData",
            jsonData,
            lang.hitch(this, this._onGetResourcePickerDataResponse),
            lang.hitch(this, this._onGetResourcePickerDataError),
            false
        );
    }

    protected _onGetResourcePickerDataResponse(response: ResourcePicker.ResourcePickerConfiguration): void {

        this.StandbyStop("resourcepicker");

        if (this.bookingResourcePicker != null) {
            this.bookingResourcePicker.destroy();
        }

        


        this.bookingResourcePicker = new ResourcePicker();
        this.bookingResourcePicker.setAllowDrag(true);
        this.bookingResourcePicker.setupDragAndDrop({
            itemEnableDragCallback: lang.hitch(this, this._onCheckItemDrag),
            itemDroppedCallback: lang.hitch(this, this._onItemDropped)
        })
        this.bookingResourcePicker.on("dndInProgress", lang.hitch(this, this._onDndInProgress))
        this.bookingResourcePicker.on("tableCreated", lang.hitch(this, this._onResourcePicker_Created))

        this.bookingResourcePicker.setConfiguration(response);
        this.bookingResourcePicker.setBaseUnits(2, 1);
        //this.logisticResourcesPicker.setLayout(null, "fixedCentered");
        this.bookingResourcePicker.setLayout(null, "fullwidth");

        this.bookingResourcePicker.placeAt(this.resourcePickerCalendarContainer);

        this.bookingResourcePicker.adjustHeightFactorToContent(3, 0.5);

        this.changeFilterDateBookedSections(0);

    }

    private _onResourcePicker_Created() {
        if (this.truckTable) {
            this.truckTable.handleNodesDisplayState(this.bookingResourcePicker);
        }
    }

    private _onCheckItemDrag(dndData: ResourcePicker.DragDropProcessData<ResourcePicker.ResourceEntry>): boolean {
        return true; // dndData.item.groupValue == "UNPLANNED";
    }

    private _onItemDropped(dndData: ResourcePicker.DragDropProcessData<ResourcePicker.ResourceEntry>): boolean {
        this._onDndInProgress({ node: dndData.draggedNode, item: dndData.item });

        return true;

    }
    private _onDndInProgress(dndData: { node: HTMLElement, item: ResourcePicker.ResourceEntry }) {
        console.log("_onDndInProgress", dndData.item, dndData.node);

        this.currentDndItem = dndData.item;
        this.currentDndNode = dndData.node;

        if (this.truckTable != null) {
            this.truckTable.currentDndItem = this.currentDndItem;
            this.truckTable.currentDndNode = this.currentDndNode;
        }
    }

    protected _onGetResourcePickerDataError(error): void {
        this.StandbyStop();
        console.warn("_onGetResourcePickerDataError", error);
        
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.useStandbyManager = true;

        this.RequestManager.handleAs = "jsonWithDate";


        this._setupResourcePicker();
    }

    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }

    startup() {
        super.startup.apply(this, arguments as any);

        let pDivision = this.getUrlParameterValue("division") as string;

        this.divisionID = localStorage.getItem("Ti_DivisionID");

        if (pDivision) {
            this.divisionID = pDivision;
        }

        this.UiModder.domClass.remove(this.section1_bookingFilter, "w3-hide");
        this.loadDivisions();
        
    }
}

export default mdsWidget(TiUnloadingForm);